;(function($$){
	function Loc(data){
        this.img_path = $('.main-menu__submenu-map__detail > .col-map > .bg-map').attr('img_path');
        this.title = $('.main-menu__submenu-map__detail__title');
        this.direction = $('.main-menu__submenu-map__detail__direction');
        this.phone = $('.main-menu__submenu-map__detail__tel');
        this.free_phone = $('.main-menu__submenu-map__detail__other > div:eq(0)');
        this.fax = $('.main-menu__submenu-map__detail__other > div:eq(1)');
        this.share = $('.main-menu__submenu-map__detail_info .bt-link');
        this.map_image = $('.main-menu__submenu-map__detail > .col-map > .bg-map');
    }
    Loc.prototype.setTitle = function(text){
        this.title.text(text);
        return this;
    }
    Loc.prototype.setDirection = function(text){
        if (text === false){
            this.direction.hide();
            return this;
        }
        this.direction.show();
        this.direction.find('span').text('');
        this.direction.find('span').append(text);
        return this;
    }
    Loc.prototype.setPhone = function(text){
        if (text === false){
            this.phone.hide();
            return this;
        }
        this.phone.show();
        this.phone.find('span').text('');
        this.phone.find('span').append(text);
        return this;
    }
    Loc.prototype.setFreePhone = function(text){
        if (text === false){
            this.free_phone.hide();
            return this;
        }
        this.free_phone.show();
        this.free_phone.find('span').text('');
        this.free_phone.find('span').append(text);
        return this;
    }
    Loc.prototype.setFax = function(text){
        if (text === false){
            this.fax.hide();
            return this;
        }
        this.fax.show();
        this.fax.find('span').text('');
        this.fax.find('span').append(text);
        return this;
    }
    Loc.prototype.setShare = function(href){
        this.share.attr('href', href);
        return this;
    }
    Loc.prototype.setMapImage = function(image){
        this.map_image.css('background-image', 'url(' + this.img_path + image + ')');
        return this;
    }
    Loc.prototype.init = function (data){
        var Loc = this;
        data.forEach(function (marker){
            $('.main-menu__submenu-map__general').append($('<div><svg class="inline-marker" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.97 24.02"><path class="path" d="M8.48 12.38a3.87 3.87 0 113.84-3.86 3.85 3.85 0 01-3.84 3.86M8.48 0A8.51 8.51 0 00-.03 8.55c0 4.46 3.84 10.21 6.41 13 1 1.05 2.07 2.46 2.07 2.46s1.2-1.42 2.23-2.5c2.57-2.68 6.26-8.07 6.26-13A8.52 8.52 0 008.48 0"/></svg></div>')
            .addClass('marker marker-' + marker.slug)
            .on('click', function (e){
                e.preventDefault();
                Loc
                    .setTitle(marker.name)
                    .setDirection(marker.hasOwnProperty('address') ? marker.address :  false)
                    .setPhone(marker.hasOwnProperty('phone') ? marker.phone :  false)
                    .setFreePhone(marker.hasOwnProperty('free_phone') ? marker.free_phone :  false)
                    .setFax(marker.hasOwnProperty('fax') ? marker.fax :  false)
                    .setShare(marker.share)
                    .setMapImage(marker.image);

                var $this = $(this);
                if ($(window).width() >= 1024) {
                    $this.closest('.main-menu__submenu').addClass('detail-open');
                } else {
                    $this.closest('.main-menu__submenu-map__general').slideToggle(function() {
                        setTimeout(function() {
                            $this.closest('.main-menu__submenu').addClass('detail-open');
                            $this.closest('.main-menu__submenu-map').find('.main-menu__submenu-map__detail').slideToggle();
                        }, 120);
                    });
                }
            }));
        });
    }
    $$.Loc = Loc;
})(window)